module.exports = __webpack_public_path__ + "media/components/assets/sujung_08-f759c26d99a2351e85a4928666f118d5.png";